'use client';

import React, { useEffect, useState } from 'react';
import { useSearchParams, useRouter, usePathname } from 'next/navigation';
import { apiOfferDetails } from '@/apis/offers';
import OfferDetailModal from './OfferDetailModal';

interface OfferDetailModalFromQueryProps {
    context?: {
        companyId?: string;
        domain?: string;
        store_slug?: string;
        slug_type?: string;
        category_slug?: string;
        promotion_slug?: string;
        out_link?: string;
    };
}

/**
 * The second tab trackOutUrl's click handler opens (LinkComponent.tsx /
 * OfferOutUrl.tsx) lands on the store page with ?show=true&p_id=<unique_id>
 * in the URL — this reads those params, fetches that one offer's full
 * details (get_offer_detail, same API Theme-11's OffersListView.tsx already
 * uses for the same purpose), and shows it in the shared OfferDetailModal
 * automatically, without needing it to already be in whatever the page's
 * own card grid happens to have fetched.
 */
const OfferDetailModalFromQuery: React.FC<OfferDetailModalFromQueryProps> = ({ context }) => {
    const searchParams = useSearchParams();
    const router = useRouter();
    const pathname = usePathname();
    const [offer, setOffer] = useState<any | null>(null);

    const show = searchParams.get('show');
    const offerId = searchParams.get('p_id');

    useEffect(() => {
        if (show !== 'true' || !offerId || !context?.companyId) return;
        let cancelled = false;

        apiOfferDetails(offerId, context.companyId)
            .then((response) => {
                if (!cancelled && response?.data) setOffer(response.data);
            })
            .catch((error) => {
                console.error('Error fetching offer details:', error);
            });

        return () => {
            cancelled = true;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [show, offerId, context?.companyId]);

    if (!offer) return null;

    const handleClose = () => {
        setOffer(null);
        const params = new URLSearchParams(searchParams.toString());
        params.delete('show');
        params.delete('p_id');
        const query = params.toString();
        router.replace(query ? `${pathname}?${query}` : pathname);
    };

    return <OfferDetailModal data={offer} context={context} onClose={handleClose} />;
};

export default OfferDetailModalFromQuery;
